import { Controller } from 'react-hook-form';
import { Select, SelectSize, Textarea } from '@ui/src';
import { QuestionTypes } from './types';

import cn from './aml.module.css';

const Question = ({
  question,
  active,
  control,
  name,
  additionalName,
  additionalList,
  setValue,
  additionalQuestion,
  textarea,
  mainList,
  answer,
  details,
  disabled,
}: QuestionTypes) => (
  <div className={cn.questionWrapper}>
    <div className={`${cn.question} ${cn.active}`}>{question}</div>
    <div className={`${cn.answer} ${active ? cn.active : ''}`}>
      {!control && (
        <>
          {answer}
          {details && <div className={cn.answerDetails}>{details}</div>}
        </>
      )}
      {control && (
        <>
          <Controller
            control={control}
            name={name}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                name={name}
                placeholder="Select «Yes» or «No»"
                list={
                  mainList || [
                    { name: 'Yes', value: 'yes' },
                    { name: 'No', value: 'no' },
                  ]
                }
                value={value as string}
                onChange={(e) => {
                  onChange(e);
                  if (e.target.value === 'no' && additionalName && setValue) {
                    setValue(additionalName, '');
                  }
                }}
                className="borderless"
                size={SelectSize.SMALL}
                disabled={disabled}
                fullWidth
              />
            )}
          />
          {active && additionalName && (
            <div className={cn.additionalQuestion}>
              <div className={cn.additionalQuestionTitle}>
                {additionalQuestion}
              </div>
              <div className={cn.additionalQuestionSelect}>
                {additionalList && additionalList.length > 0 && (
                  <Controller
                    control={control}
                    name={additionalName}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                      <Select
                        name={name}
                        placeholder="Select option"
                        list={additionalList}
                        value={value as string}
                        onChange={onChange}
                        className="borderless"
                        size={SelectSize.SMALL}
                        disabled={disabled}
                        fullWidth
                      />
                    )}
                  />
                )}
                {textarea && (
                  <Controller
                    control={control}
                    name={additionalName}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                      <Textarea
                        name={name}
                        placeholder="Enter details"
                        value={value as string}
                        onChange={onChange}
                        className={cn.rowTextarea}
                        disabled={disabled}
                      />
                    )}
                  />
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  </div>
);

export default Question;
